module.exports = __webpack_public_path__ + "static/media/Cozy_Compact.2d59fd00.svg";